import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from '../services/app.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';
import { ProgressBarService } from '../services/progress-bar.service';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(
    private app: AppService,
    private router: Router,
    private progressService: ProgressBarService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let url = "";
    if (!req.url.startsWith("https://")) {
      url = environment.api_url;
    }

    const token = localStorage.getItem('jwtToken') || '';

    // Check if it's a file upload request
    const isFileUpload = req.body instanceof FormData;

    // Skip Authorization header override for inbound agent APIs (sandbox + prod)
    const isInboundAgentAPI = req.url.includes('sandbox-websocket.houseofagents.ai') || req.url.includes('prd-websocket.houseofagents.ai');

    let clonedRequest = req.clone({
      url: url + req.url,
      headers: isInboundAgentAPI ? req.headers : req.headers.set('Authorization', token)
    });

    // Only set Content-Type for non-file uploads
    if (!isFileUpload) {
      clonedRequest = clonedRequest.clone({
        headers: clonedRequest.headers
          .set('Content-Type', 'application/json; charset=utf-8')
          .set('Accept', 'application/json; charset=utf-8')
      });
    }

    // Show progress bar
    this.progressService.show();

    // Handle the request
    return next.handle(clonedRequest).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.progressService.hide();
          }
        },
        (error) => {
          this.progressService.hide();
        }
      )
    );
  }
}
